import { i18n } from "./i18n";
const en = {
  maintenanceTitle: "We’ll be back shortly",
  maintenanceBody:
    "Live Room is undergoing maintenance. Please try again shortly. This page updates automatically.",
  serverFull: "The server is full.",
  existingLimitHint:
    "Current saved limit: {{current}}. It stays unchanged unless you adjust the control.",
  limitMaxHint: "Maximum participants: {{max, number}}.",
  hello: "Good to see you,",
  noParticipants: "No participants in this room",
  noCode: "No passcode",
  limitShort: "Participant limit",
  publicVisibilityHint: "Anyone can find this room in Public rooms.",
  publicShort: "Public",
  privateShort: "Private",
  copyCode: "Copy passcode",
  copyCurrentCode: "Copy current passcode",
  codeCopied: "Passcode copied.",
  leaveRecent: "Remove from recent",
  visibility: "Visibility",
  visibilityHint: "Only people with the link can join.",
  codeOnceHint: "Only required the first time someone joins the room.",
  editCodeHint: "Previously approved accounts keep their access.",
  publicRemovesCodeTitle: "The passcode will be removed",
  publicRemovesCodeBody: "Public rooms can’t have a passcode. Anyone will be able to join.",
  hasCode: "This room has a passcode",
  editingCode: "Passcode changed",
  codeRestored: "Original passcode restored",
  codeLoadFailed: "Couldn’t load the passcode. You can replace or remove it.",
  codeRemovalPending: "The passcode will be removed when you save",
  removeCodeAction: "Remove passcode",
  undoCodeRemoval: "Undo",
  showCode: "Show passcode",
  hideCode: "Hide passcode",
  codeCopySuccess: "Copied",
  codeCopyFailed: "Couldn’t copy the passcode. Try again.",
  copyUrl: "Copy link",
  copied: "Link copied.",
  copyFailed: "Couldn’t copy the link.",
  edit: "Edit room",
  delete: "Delete room",
  save: "Save changes",
  saving: "Saving…",
  deleting: "Deleting…",
  discardTitle: "Discard changes?",
  discardBody: "Your changes to this room will be lost.",
  keepEditing: "Keep editing",
  discard: "Discard",
  editTitle: "Room settings",
  editBody: "Update {{name}}. Its link stays the same.",
  limitDecrease: "Fewer participants",
  limitIncrease: "More participants",
  deleteTitle: "Delete this room?",
  deleteBody: "{{name}} will be removed and everyone will be disconnected. This cannot be undone.",
  occupancyLabel: "{{count}} of {{max}} participants",
  passcodeRequired: "Passcode required",
  connectionMoved: "You joined this room somewhere else, so we disconnected you here.",
  callEnded: "Your call ended.",
  rooms: "Rooms",
  recent: "Recent rooms",
  public: "Public rooms",
  create: "Create room",
  creating: "Creating…",
  createTitle: "Start a room.",
  createDescription: "A space for your people. Give it a name and make yourself at home.",
  name: "Room name",
  namePlaceholder: "Somewhere to hang out",
  password: "Passcode",
  optional: "optional",
  limit: "Maximum participants",
  limitHint: "All the way to the left means no limit.",
  unlimited: "No limit",
  join: "Join room",
  joining: "Joining…",
  owner: "by {{name}}",
  emptyRecentTitle: "Your people, your places.",
  emptyRecentBody:
    "Rooms you join will find a home here. Explore a public room or create your own.",
  emptyPublicTitle: "A little quiet in here.",
  emptyPublicBody: "Be the first to make a space. Good company starts with a room.",
  loading: "Finding your rooms…",
  reconnecting: "Reconnecting to live updates…",
  retry: "Try again",
  back: "Back to home",
  leave: "Leave room",
  protectedTitle: "A word before you enter.",
  protectedBody: "Enter the passcode for {{name}}. We’ll only ask once per account.",
  unavailable: "This room is unavailable.",
  full: "This room is full.",
  fullBody: "All the places are taken right now. Try again in a moment.",
  more_one: "{{count}} more participant",
  more_other: "{{count}} more participants",
  presenceUnavailable: "Live presence unavailable",
  errors: {
    "room-creation-closed": "Creating rooms is temporarily disabled. Please try again later.",
    "rooms-per-user-limit":
      "You’ve reached the limit for rooms you can create. Delete one of your rooms before creating another.",
    "rooms-per-user-limit-known":
      "Your room limit is {{limit, number}}. Delete one of your rooms before creating another.",
    "participant-limit":
      "Maximum participants: {{max, number}}. The server’s limit may have changed.",
    "server-full": "All server places are taken right now. Please try again shortly.",
    "room-code-unavailable": "This passcode can’t be copied. Ask the owner to set it again.",
    "room-code-forbidden": "Join the room before copying its passcode.",
    "invalid-room-visibility": "Choose public or private.",
    "room-owner-required": "Only the owner can change this room.",
    "room-not-found": "This room doesn’t exist or you don’t have access to it.",
    "room-create-failed": "We couldn’t create the room. Please try again.",
    "authentication-required": "Your session expired. Please sign in again.",
    "incorrect-password": "That passcode doesn’t match. Try again.",
    "password-required": "Enter the room passcode to continue.",
    "room-full": "This room is full. Please try again in a moment.",
    "rate-limited": "A few too many attempts. Please wait a minute.",
    "invalid-room-name": "Enter a room name with 1–80 characters.",
    "invalid-room-limit": "Choose from 1 to {{max, number}} participants, or no limit.",
    "invalid-room-password": "Use a passcode with at most 6 characters.",
    "public-room-password": "Only private rooms can have a passcode.",
    default: "Something went wrong. Please try again.",
    "room-connection-unavailable": "We couldn’t connect to the room. Please try again.",
    "livekit-not-configured": "The room service isn’t configured yet.",
  },
};
const pt = {
  maintenanceTitle: "Voltaremos em breve",
  maintenanceBody:
    "O Live Room está em manutenção. Tente novamente em breve. Esta página é atualizada automaticamente.",
  serverFull: "O servidor está cheio.",
  existingLimitHint:
    "Limite salvo atual: {{current}}. Ele será mantido se você não ajustar o controle.",
  limitMaxHint: "Máximo de participantes: {{max, number}}.",
  hello: "Que bom te ver,",
  noParticipants: "Nenhum participante nesta sala",
  noCode: "Sem senha",
  limitShort: "Limite de pessoas",
  publicVisibilityHint: "Qualquer pessoa pode encontrar esta sala em Salas públicas.",
  publicShort: "Pública",
  privateShort: "Privada",
  copyCode: "Copiar senha da sala",
  copyCurrentCode: "Copiar senha atual",
  codeCopied: "Senha da sala copiada.",
  leaveRecent: "Remover dos recentes",
  visibility: "Visibilidade",
  visibilityHint: "Só quem tiver o link pode entrar.",
  codeOnceHint: "Só é pedida na primeira vez que alguém entra na sala.",
  editCodeHint: "Contas já autorizadas mantêm o acesso.",
  publicRemovesCodeTitle: "A senha será removida",
  publicRemovesCodeBody: "Salas públicas não podem ter senha. Qualquer pessoa poderá entrar.",
  hasCode: "Esta sala tem uma senha",
  editingCode: "Senha alterada",
  codeRestored: "Senha original restaurada",
  codeLoadFailed: "Não foi possível carregar a senha. Você pode substituí-la ou removê-la.",
  codeRemovalPending: "A senha será removida ao salvar",
  removeCodeAction: "Remover senha",
  undoCodeRemoval: "Desfazer",
  showCode: "Mostrar senha",
  hideCode: "Ocultar senha",
  codeCopySuccess: "Copiada",
  codeCopyFailed: "Não foi possível copiar a senha. Tente novamente.",
  copyUrl: "Copiar link",
  copied: "Link copiado.",
  copyFailed: "Não foi possível copiar o link.",
  edit: "Editar sala",
  delete: "Excluir sala",
  save: "Salvar alterações",
  saving: "Salvando…",
  deleting: "Excluindo…",
  discardTitle: "Descartar alterações?",
  discardBody: "As alterações nesta sala serão perdidas.",
  keepEditing: "Continuar editando",
  discard: "Descartar",
  editTitle: "Configurações da sala",
  editBody: "Atualize {{name}}. O link continua o mesmo.",
  limitDecrease: "Menos participantes",
  limitIncrease: "Mais participantes",
  deleteTitle: "Excluir esta sala?",
  deleteBody:
    "{{name}} será removida e todos serão desconectados. Esta ação não pode ser desfeita.",
  occupancyLabel: "{{count}} de {{max}} participantes",
  passcodeRequired: "Protegida por senha",
  connectionMoved: "Você entrou nesta sala em outro lugar, então desconectamos você aqui.",
  callEnded: "Sua chamada foi encerrada.",
  rooms: "Salas",
  recent: "Salas recentes",
  public: "Salas públicas",
  create: "Criar sala",
  creating: "Criando…",
  createTitle: "Crie uma sala.",
  createDescription: "Um espaço para sua galera. Dê um nome e fique à vontade.",
  name: "Nome da sala",
  namePlaceholder: "Trocar idea",
  password: "Senha",
  optional: "opcional",
  limit: "Máximo de participantes",
  limitHint: "Arraste totalmente para a esquerda para não limitar.",
  unlimited: "Sem limite",
  join: "Entrar na sala",
  joining: "Entrando…",
  owner: "por {{name}}",
  emptyRecentTitle: "Sua galera, seus lugares.",
  emptyRecentBody: "As salas que você visitar ficam aqui. Explore uma sala pública ou crie a sua.",
  emptyPublicTitle: "Tudo quietinho por aqui.",
  emptyPublicBody: "Que tal abrir um espaço? Uma boa companhia começa com uma sala.",
  loading: "Buscando suas salas…",
  reconnecting: "Reconectando às atualizações ao vivo…",
  retry: "Tentar novamente",
  back: "Voltar ao início",
  leave: "Sair da sala",
  protectedTitle: "Uma palavra antes de entrar.",
  protectedBody: "Digite a senha de {{name}}. Vamos pedir apenas uma vez por conta.",
  unavailable: "Esta sala não está disponível.",
  full: "Esta sala está cheia.",
  fullBody: "Todas as vagas estão ocupadas agora. Tente novamente daqui a pouco.",
  more_one: "Mais {{count}} participante",
  more_other: "Mais {{count}} participantes",
  presenceUnavailable: "Presença ao vivo indisponível",
  errors: {
    "room-creation-closed":
      "A criação de salas está temporariamente desativada. Tente novamente mais tarde.",
    "rooms-per-user-limit":
      "Você atingiu o limite de salas que pode criar. Exclua uma de suas salas antes de criar outra.",
    "rooms-per-user-limit-known":
      "Seu limite de salas é {{limit, number}}. Exclua uma de suas salas antes de criar outra.",
    "participant-limit":
      "Máximo de participantes: {{max, number}}. O limite do servidor pode ter mudado.",
    "server-full": "Todas as vagas do servidor estão ocupadas. Tente novamente em breve.",
    "room-code-unavailable":
      "Não é possível copiar esta senha. Peça para quem criou a sala defini-la novamente.",
    "room-code-forbidden": "Entre na sala antes de copiar a senha.",
    "invalid-room-visibility": "Escolha pública ou privada.",
    "room-owner-required": "Apenas quem criou a sala pode alterá-la.",
    "room-not-found": "Esta sala não existe ou você não tem acesso a ela.",
    "room-create-failed": "Não foi possível criar a sala. Tente novamente.",
    "authentication-required": "Sua sessão expirou. Entre novamente.",
    "incorrect-password": "Essa senha não confere. Tente novamente.",
    "password-required": "Digite a senha da sala para continuar.",
    "room-full": "Esta sala está cheia. Tente novamente em instantes.",
    "rate-limited": "Muitas tentativas. Aguarde um minuto.",
    "invalid-room-name": "Use um nome de sala com 1 a 80 caracteres.",
    "invalid-room-limit": "Escolha entre 1 e {{max, number}} participantes ou deixe sem limite.",
    "invalid-room-password": "Use uma senha com até 6 caracteres.",
    "public-room-password": "Apenas salas privadas podem ter senha.",
    default: "Algo deu errado. Tente novamente.",
    "room-connection-unavailable": "Não foi possível conectar à sala. Tente novamente.",
    "livekit-not-configured": "O serviço de salas ainda não foi configurado.",
  },
};
i18n.addResourceBundle("en", "translation", { home: en }, true, true);
i18n.addResourceBundle("pt-BR", "translation", { home: pt }, true, true);
